import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/Detail/DetailApartmentContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/web82.sr14.firestorm.ch/pension-hohenau.at/src/components/sections/HeroBanner/DetailPageClient.tsx");
